import { useEffect, useState } from 'react';
import { getCommission } from '../api/commissions.api';
import type { Commission } from '../types/commission.types';

export function useCommission(id: string | undefined) {
  const [commission, setCommission] = useState<Commission | null>(null);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getCommission(id).then(setCommission).catch(() => setError('خطا در دریافت جزئیات کمیسیون')).finally(() => setLoading(false));
  }, [id]);

  return { commission, loading, error };
}
